import cx from 'classnames'
import IntlMessage from '../../common/intl/intl_message'
import React from 'react'
import PropTypes from 'prop-types'

function MenuItemSecondary (props) {
  const { icon, title, navigateTo, className, active, ...other } = props

  return (
    <button
      className={cx(
        'sidebar__menu-item-secondary',
        { 'sidebar__menu-item-secondary--active': active },
        className
      )}
      {...other}
    >
      <div className='sidebar__menu-item-secondary__icon'>{icon}</div>
      <span className='sidebar__menu-item-secondary__title'>
        <IntlMessage ident={title} />
      </span>
    </button>
  )
}

MenuItemSecondary.propTypes = {
  active: PropTypes.bool,
  classname: PropTypes.string,
  icon: PropTypes.element,
  navigateTo: PropTypes.func,
  title: PropTypes.string
}

export { MenuItemSecondary }
